import { defineComponent as p, openBlock as s, createElementBlock as l, withModifiers as r, createElementVNode as n, normalizeClass as a, renderSlot as e } from "vue";
import { _ as d } from "../../../_plugin-vue_export-helper-dad06003.js";
const c = p({
  name: "VTooltipWrapper",
  data() {
    return {
      isTooltipVisible: !1
    };
  },
  methods: {
    toggleTooltip() {
      this.isTooltipVisible = !this.isTooltipVisible;
    }
  }
});
function _(o, t, m, f, T, g) {
  return s(), l("div", {
    class: "hobi-tooltip-wrapper",
    onClick: t[0] || (t[0] = r((...i) => o.toggleTooltip && o.toggleTooltip(...i), ["stop"]))
  }, [
    n("span", {
      class: a([
        "hobi-tooltip-wrapper__content",
        o.isTooltipVisible ? "" : "hobi-tooltip-wrapper__content-hidden"
      ])
    }, [
      e(o.$slots, "tooltip-content", {}, void 0, !0)
    ], 2),
    e(o.$slots, "tooltip-trigger", {}, void 0, !0)
  ]);
}
const b = /* @__PURE__ */ d(c, [["render", _], ["__scopeId", "data-v-120cc687"]]);
export {
  b as default
};
